import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/devices/")({
  component: DevicesIndex,
});

function DevicesIndex() {
  return (
    <div className="flex h-full items-center justify-center text-sm text-olive-11">
      Select a device
    </div>
  );
}
